/**
 * 参数配置相关请求(昆仑山3.0设备)
 */
import request from "@/utils/request";
import {getLXConfigParams} from "@/constants/parameterConfiguration";

// 处理请求参数
const operateRequestParams = (params: any) => {
  const reuqestParams = {...params};
  delete reuqestParams.sn;
  return {
    reuqestParams,
    sn: params.sn,
  };
};

// 获取车身类型数据
export const getJtKlsCarTypeRequest = (sn: string) => {
  return request.get(`/808/aebs/vehicleType/${sn}`, {
    headers: {"sn-agent": sn},
  });
};

// 设置车身类型
export const setJtKlsCarTypeRequest = (data: any) => {
  const {sn, type} = data;
  return request.put(
    `/808/aebs/vehicleType/${sn}`,
    {carType: type},
    {headers: {"sn-agent": sn}}
  );
};

// 获取软硬件信息数据
export const getJtKlsWareInfoRequest = (sn: string) => {
  return request.get(`/808/aebs/deviceInfo/${sn}`, {
    headers: {"sn-agent": sn},
  });
};

// 获取AEB参数配置
export const getJtKlsAebParamsRequest = (sn: string) => {
  return request.get(`/808/aebs/aebConfig/${sn}`, {
    headers: {"sn-agent": sn},
  });
};
//获取AEB参数配置(新版本，适用于畅行领行设备)
export const getJtChangxingLingxingAebParamsRequest = async (sn: string) => {
  const res = await request.get(`/808/aebs/aebConfig/${sn}`, {
    headers: {"sn-agent": sn},
  });

  const resData = res.data || {};
  const allLingxingChangxingParams = getLXConfigParams();

  console.log(resData);

  return res;
};

// 设置AEB参数配置
export const setJtKlsAebParamsRequest = (data: any) => {
  const {reuqestParams, sn} = operateRequestParams(data);
  return request.put(`/808/aebs/aebConfig/${sn}`, reuqestParams, {
    headers: {"sn-agent": sn},
  });
};

//设置领行畅行AEB参数配置
export const setJtChangxingLingxingAebParamsRequest = (data: any) => {
  const {reuqestParams, sn} = operateRequestParams(data);

  // 处理特殊参数,
  for (const key in reuqestParams) {
    if (reuqestParams[key] === true) {
      reuqestParams[key] = 1;
    } else if (reuqestParams[key] === false) {
      reuqestParams[key] = 0;
    }

  }

  return request.put(`/808/aebs/aebConfig/${sn}`, reuqestParams, {
    headers: {"sn-agent": sn},
  });
};

// 获取传感器配置信息
export const getJtKlsSensorParamsRequest = (sn: string) => {
  return request.get(`/808/aebs/sensorConfig/${sn}`, {
    headers: {"sn-agent": sn},
  });
};

// 设置传感器配置
export const setJtKlsSensorParamsRequest = (data: any) => {
  const {reuqestParams, sn} = operateRequestParams(data);
  return request.put(`/808/aebs/sensorConfig/${sn}`, reuqestParams, {
    headers: {"sn-agent": sn},
  });
};

// 获取相机参数
export const getJtKlsCameraParamsRequest = (sn: string) => {
  return request.get(`/808/aebs/cameraConfig/${sn}`, {
    headers: {"sn-agent": sn},
  });
};

// 设置相机参数
export const setJtKlsCameraParamsRequest = (data: any) => {
  const {reuqestParams, sn} = operateRequestParams(data);
  return request.put(`/808/aebs/cameraConfig/${sn}`, reuqestParams, {
    headers: {"sn-agent": sn},
  });
};

// 获取拉线电机参数
export const getJtKlsCableMotorParamsRequest = (sn: string) => {
  return request.get(`/808/aebs/pullingMotorConfig/${sn}`, {
    headers: {"sn-agent": sn},
  });
};

// 设置拉线电机参数
export const setJtKlsCableMotorParamsRequest = (data: any) => {
  const {reuqestParams, sn} = operateRequestParams(data);
  return request.put(`/808/aebs/pullingMotorConfig/${sn}`, reuqestParams, {
    headers: {"sn-agent": sn},
  });
};

// 设置CAN dbc配置
export const setJtKlsCanDbcRequest = (data: any) => {
  return request.put(`/808/aebs/canDbcConfig/${data.sn}`, data.reuqestParams, {
    headers: {"sn-agent": data.sn},
  });
};

// 通过SN获取dbc文件
export const queryCanDbc = (sn: any) => {
  return request.get(`/api/v2/canInfo/queryCanDbc/${sn}`);
};
